import React, { FC } from "react";
import { ArtifactV1SessionPart, ArtifactV1SessionPartKind } from "../../session.types";
import { SessionPartContext } from "../session-part.types";
import { MDSSessionArtifactNoteCreatedV1Part } from "./session-artifact-note-created-v1-part";
import { MDSSessionArtifactNoteUpdatedV1Part } from "./session-artifact-note-updated-v1-part";

interface Props {
  part: ArtifactV1SessionPart;
  context: SessionPartContext;
}

export const MDSSessionArtifactV1Part: FC<Props> = ({ part, context }) => {
  switch (part.artifact_kind) {
    case ArtifactV1SessionPartKind.NoteCreatedV1:
      return <MDSSessionArtifactNoteCreatedV1Part part={part} context={context} />;
    case ArtifactV1SessionPartKind.NoteUpdatedV1:
      return <MDSSessionArtifactNoteUpdatedV1Part part={part} context={context} />;
    default:
      return null;
  }
};
